/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.access.controls.rpc.AiAccessControlsChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './AiAccessControlsChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.access.controls.rpc.AiAccessControlsChirpService#getAccessControls
 */
export const GET_ACCESS_CONTROLS_QUERY_FIELD_NAME = 'com_hubspot_ai_access_controls_rpc_AiAccessControlsChirpService_getAccessControls';
export const GET_ACCESS_CONTROLS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ACCESS_CONTROLS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAccessControlsRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.access.controls.rpc.AiAccessControlsChirpService#patchAccessControls
 */
export const PATCH_ACCESS_CONTROLS_MUTATION_FIELD_NAME = 'com_hubspot_ai_access_controls_rpc_AiAccessControlsChirpService_patchAccessControls';
export const PATCH_ACCESS_CONTROLS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: PATCH_ACCESS_CONTROLS_MUTATION_FIELD_NAME,
  args: ['generativeAiEnabled', 'crmPropertiesEnabled', 'conversationDataEnabled', 'fileDataEnabled', 'copilotEnabled'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.patchAccessControlsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});